/* eslint-disable */
export default {
  noActiveCalls: 'No active calls',
  noRecords: 'No results found.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
